import {Breakpoint} from '@/utils';
import {
  Typography,
  SxProps,
  Theme,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {ReactNode} from 'react';

interface ResponsiveTypographyProps {
  children?: ReactNode;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  smallerXs?: boolean;
  larger?: boolean;
  medium?: boolean;
  mediumSmall?: boolean;
  verySmallXs?: boolean;
  smallAllSizes?: boolean;
  mediumAllSizes?: boolean;
  truncateText?: boolean;
  breakpoint?: Breakpoint;
  textMaxWidth?: string;
  alwaysTruncate?: boolean;
}

const ResponsiveTypography: React.FC<ResponsiveTypographyProps> = ({
  children,
  sx,
  onClick,
  smallerXs,
  larger,
  medium,
  mediumSmall,
  verySmallXs,
  smallAllSizes,
  mediumAllSizes,
  truncateText,
  breakpoint = 'lg',
  textMaxWidth = '26ch',
  alwaysTruncate
}) => {
  let baseFontSizes;

  const theme = useTheme();
  const isDown = useMediaQuery(theme.breakpoints.down(breakpoint));

  if (larger) {
    baseFontSizes = {
      xs: '1.2rem',
      sm: '1.6rem',
      md: '2rem'
    };
  } else if (medium) {
    baseFontSizes = {
      xs: '1.1rem',
      sm: '1.4rem',
      md: '1.5rem'
    };
  } else if (mediumSmall) {
    baseFontSizes = {
      xs: '0.9rem',
      sm: '1rem',
      md: '1.1rem'
    };
  } else if (mediumAllSizes) {
    baseFontSizes = {
      xs: '0.6rem',
      sm: '0.7rem'
    };
  } else if (smallAllSizes) {
    baseFontSizes = {
      xs: '0.55rem',
      sm: '0.65rem'
    };
  } else {
    baseFontSizes = {
      xs: verySmallXs ? '0.35rem' : smallerXs ? '0.5rem' : '0.6rem',
      sm: '0.8rem',
      md: '1rem'
    };
  }

  return (
    <Typography
      sx={{
        fontSize: baseFontSizes,
        ...(truncateText &&
          (isDown || alwaysTruncate) && {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: textMaxWidth
          }),
        ...sx
      }}
      onClick={onClick}
    >
      {children}
    </Typography>
  );
};

export default ResponsiveTypography;
